import modules from "@gotombola/react-ds/lib/template-modules/organization";

export default {
    ...modules,
}